import React from "react";

function PageHeader({ title }) {
  return (
    <div
      style={{
        maxWidth: "600px",
        width: "90%",
        margin: "0 auto 30px auto",
        textAlign: "center",
        borderBottom: "3px solid #012459ff",
        padding: "10px 0",
      }}
    >
      <h1
        className="display-6 mb-0"
        style={{
          color: "#012459ff",
          letterSpacing: "0.5px",
        }}
      >
        {title}
      </h1>
    </div>
  );
}

export default PageHeader;